import React from 'react';
//import axios from 'axios';
import { Link } from 'react-router-dom';
import CustomButton from '../../customButton';
//import { Image } from 'react-bootstrap';
import productCard from './productCards.module.css';
import FormModal from '../../formModal';
import UpdateForm from '../updateProduct/updateProduct';
import { axiosAuthFetch } from '../../../helpers/apiActions/authFetch';

export function VpAdminProductCard({ product }) {

    const {name, varenummer, image, visible, service_form} = product.attributes;

    console.log(service_form);

    console.log('service Form!!!', product.attributes);

    const supplier = product.attributes.supplier.data.attributes.name;

    const removeProduct = async (id) => {
        const confirmDelete = window.confirm('Er du helt sikker på at du vil slette dette produktet? Hvis du sletter kan det ikke angres.');
        if (confirmDelete) {
            try {
                // Sjekk om det er en token i localStorage
                const token = localStorage.getItem('token');
                if (!token) {
                    // Hvis det ikke er noen token, be brukeren om å logge inn først
                    console.log('Vennligst logg inn først');
                    return;
                }
    
                // Send delete-forespørselen med autentiseringsheader
                await axiosAuthFetch(`https://renowned-oasis-58a898da10.strapiapp.com/api/products/${id}`, null, 'delete');
    
                // Vis en melding om at produktet er slettet
                alert('Produktet er slettet!');
    
                // Omdiriger brukeren til nettbutikken etter sletting
                window.location.href = "/VP/admin/nettbutikk";
            } catch (error) {
                // Håndter feil ved sletting av produkt
                alert('Feil ved sletting av produkt! Vennligst prøv igjen.');
                console.error('Feil ved sletting av produkt:', error);
            }
        }
    };

    const cardClassName = visible === false ? `${productCard.card} ${productCard.hidden}` : productCard.card;

    return(
            <div className={cardClassName}>
                {/* <div className="col-12">
                    <Image className={productCard.cardImage} src={image.data.attributes.url} fluid alt={name}/>
                </div> */}
                    {/* <div className={productCard.imageContainer}  */}
                    <div className={productCard.productImage}
                        style={{
                            backgroundImage: `url(${image?.data?.attributes?.url})`,
                            // backgroundRepeat: 'no-repeat',
                            // backgroundSize: 'contain',
                            // width: '10em',
                            // height: '10em',
                        }}
                    />
                <div className="">
                    <div className={productCard.produktNavn}>
                        {name}
                    </div>
                    <div className="mt-auto">
                        <p>fra {supplier}</p>
                    </div>
                    <div className="mt-auto">
                        VN: {varenummer}
                    </div>
                    <div className="text-center mt-auto">
                    <Link to={`/product/${product.id}`}>
                        <CustomButton 
                            label="Trykk for mer info"
                            className={productCard.cardButton1}
                        />
                    </Link>
                    </div>
                    <div className="text-center mt-auto">
                        <FormModal 
                            buttonTitle="Rediger info" 
                            modalTitle="Rediger produkt" 
                            body={<UpdateForm
                                product={product} />}
                            openButtonClass={productCard.cardButton2} 
                            closeButtonClass={productCard.closeButton}
                        />
                    </div>
                    <div className="text-center mt-auto">
                        <CustomButton 
                            label="Slett produkt"
                            className={productCard.cardButton3}
                            onClick={() => removeProduct(product.id)}
                        />
                    </div>
                </ div>
            </ div>
    )
}

export default VpAdminProductCard;